<div class="tw-flex tw-flex-col tw-justify-around">
  <ui-svg-icon
    [name]="iconNames.DocumentPdf"
    [width]="100"
    class="pdf-icon"
    [class.tw-cursor-pointer]="isCursorNeeded"
    (click)="onIconClick()"
  ></ui-svg-icon>
  <span> {{ fileName }} </span>
</div>
